import { render, staticRenderFns } from "./PoeChart.vue?vue&type=template&id=041eee22&"
import script from "./PoeChart.vue?vue&type=script&lang=js&"
export * from "./PoeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports